<div
    class="container"
    [formGroup]="_form.form"
>
    <div class="eval-flex">
        <div class="opp-demonstrate">
            <div class="font-weight-bold header">
                {{ _i18n._9567_OPPORTUNITY_TO_DEMONSTRATE | translate }}
            </div>
            <div class="binary-buttons">
                <cmps-button-group
                    class="cmps-button-group--rounded"
                    [formControlName]="_form.fields.OPP_TO_DEMONSTRATE.name"
                    (change)="onSelectedDemonstrate($event)"
                >
                    <button
                        class="cmps-observation-score--item"
                        [class.cmps-observation-score--yes]="
                            _form.form.controls[
                                _form.fields.OPP_TO_DEMONSTRATE.name
                            ].value
                        "
                        cmpsButtonGroupItem
                        [value]="true"
                    >
                        {{ _i18n._9297_YES | translate }}
                    </button>
                    <button
                        class="cmps-observation-score--item"
                        [class.cmps-observation-score--no]="
                            _form.form.controls[
                                _form.fields.OPP_TO_DEMONSTRATE.name
                            ].value === false
                        "
                        cmpsButtonGroupItem
                        [value]="false"
                    >
                        {{ _i18n._9298_NO | translate }}
                    </button>
                </cmps-button-group>
            </div>
        </div>

        <div
            [class.hide]="!_showWillingness"
            class="will-try"
        >
            <div class="font-weight-bold header">
                {{ _i18n._9568_WILLINGNESS_TO_TRY | translate }}
            </div>
            <div class="binary-buttons">
                <cmps-button-group
                    class="cmps-button-group--rounded"
                    [formControlName]="_form.fields.WILLINGNESS_TRY.name"
                    (change)="onSelectedWillingness($event)"
                >
                    <button
                        class="cmps-observation-score--item"
                        [class.cmps-observation-score--yes]="
                            _form.form.controls[
                                _form.fields.WILLINGNESS_TRY.name
                            ].value
                        "
                        cmpsButtonGroupItem
                        [value]="true"
                    >
                        {{ _i18n._9297_YES | translate }}
                    </button>
                    <button
                        class="cmps-observation-score--item"
                        [class.cmps-observation-score--no]="
                            _form.form.controls[
                                _form.fields.WILLINGNESS_TRY.name
                            ].value === false
                        "
                        cmpsButtonGroupItem
                        [value]="false"
                    >
                        {{ _i18n._9298_NO | translate }}
                    </button>
                </cmps-button-group>
            </div>
        </div>

        <div
            [class.hide]="!_showProficiency"
            class="proficiency-score"
        >
            <div class="font-weight-bold header2">
                {{ _i18n._7317_PROFICIENCY | translate }}
            </div>

            <div class="eval-flex-container">
                <div
                    *ngFor="let button of buttons"
                    class="eval-button-container"
                >
                    <button
                        class="cmps-icon-button--no-bg cmps-icon-button--sm"
                        cmpsIconButton
                        [class.eval-button-low-selected]="
                            button.css === 'eval-button-low-selected'
                        "
                        [class.eval-button-mid-selected]="
                            button.css === 'eval-button-mid-selected'
                        "
                        [class.eval-button-high-selected]="
                            button.css === 'eval-button-high-selected'
                        "
                        [class.eval-button-unselected]="
                            _clickedItem && _clickedItem !== button.id
                        "
                        [class.eval-button-selected]="
                            _clickedItem && _clickedItem === button.id
                        "
                        [disabled]="_form?.form.disabled"
                        (click)="onProficiencySelected(button.id)"
                    >
                        <span cmpsIconButtonLabel>{{ button.label }}</span>
                    </button>
                </div>
            </div>

            <div class="eval-label-row">
                <div
                    *ngFor="let buttonsLabel of buttonsLabels"
                    [style.width]="buttonsLabel.width"
                >
                    <strong>{{
                        buttonsLabel.name || (_i18n._842_N_A | translate)
                    }}</strong>
                </div>
            </div>
        </div>
    </div>
</div>
